<template>
  <el-card style="margin-top: 20px">
    <div slot="header" class="clearfix">
      <span>{{ title }}</span>
    </div>
    <div ref="chartContainer" style="width: 100%; height: 600px;;margin-bottom: 20px" />
  </el-card>
</template>
<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'OutputsStats',
  props: {
    keys: {
      type: Array,
      default: () => ['stock_spin', 'grant_spin', 'cost_spin', 'collect_spin', 'rank_spin', 'collect_card', 'serial_pack']
    },
    legend: {
      type: Array,
      default: () => ['累计结余', '累计产出', '累计消耗', '收集活动产出', '锦标赛产出', '连环礼包产出']
    },
    title: {
      type: String,
      default: '产出消耗'
    }
  },
  data() {
    return {

    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis'
          // axisPointer: {
          //   type: 'shadow'
          // }
        },
        series: []
      }
      this.chart.setOption(this.option)
    },
    refresh(data) {
      const date = []
      const echartData = {}
      for (const i in this.keys) {
        const key = this.keys[i]
        echartData[key] = []
      }
      for (const i in data) {
        const val = data[i]
        date.push(dateStrTodate(val.date))
        for (const k in val) {
          if (echartData[k]) {
            echartData[k].push(val[k])
          }
        }
      }
      this.option.series = []
      let idx = 0
      for (const i in echartData) {
        const val = echartData[i]
        const temp = {
          name: this.legend[idx],
          data: val,
          type: 'bar',
          label: {
            // show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
        idx++
      }
      this.option.legend.data = this.legend
      this.option.xAxis.data = date
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
